import React from "react"

import * as styles from "./list-item-nested.styled"

type ListItemNestedProps = {
  LeftIcon?: React.ReactNode
  label: string
  description?: string
  RightElement?: React.ReactNode
}

export const ListItemNested = ({
  LeftIcon,
  label,
  description,
  RightElement,
}: ListItemNestedProps) => {
  return (
    <div className={styles.container}>
      {LeftIcon ? LeftIcon : null}
      <div className={styles.textContainer}>
        <p className={styles.label}>{label}</p>
        {description ? <p className={styles.description}>{description}</p> : null}
      </div>
      {RightElement ? <div className={styles.rightElementContainer}>{RightElement}</div> : null}
    </div>
  )
}
